/**
 * @fileoverview Javascript for the enhancedlists items
 */
goog.provide('yext.storm.enhancedlists.Items');
goog.provide('yext.storm.enhancedlists.AddItems');
goog.provide('yext.storm.enhancedlists.LOGItems');

goog.require('yext');
goog.require('yext.ajax');
goog.require('yext.dam.assetselector');
goog.require('yext.dam.assetselector.events');
goog.require('yext.dialog');
goog.require('yext.fileupload');
goog.require('yext.helpers');
goog.require('yext.location.StringList');
goog.require('yext.notify');
goog.require('yext.photoupload.Photo');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');
/** @suppress {extraRequire} */
goog.require('yext.plugins.selectbox');
goog.require('yext.storm.enhancedlists');
goog.require('yext.storm.routesDEPRECATED');
goog.require('yext.time');
goog.require('yext.videochooser');
/** @suppress {extraRequire} */
goog.require('yext.plugins.ContextualHelpText');

/**
 * @constructor
 * @suppress {deprecated}
 */
yext.storm.enhancedlists.Items = function(add, isLog, isSuggestedEdit) {
  this.isAddState = add;
  this.isSuggestedEdit = isSuggestedEdit;
  var self = this;
  if (!isLog) {
    if (add) {
      this.bindFocus();
      this.bindAddItemFormSubmit();
      this.setupGallery($('form.gallery'));
      this.setupPrice();
      this.setupCalories();
      this.setupPriceOptions();
      this.bindCancelCreate();
      this.bindGeneralChangeListener();
      this.totalPhotos = this.initTotalPhotos();
    } else {
      this.bindRowHover();
      this.bindFieldEdit();
      this.bindEditFormSubmit();
      this.bindDeleteItem();
    }
    this.stringlists = [];
    $('form.string-list').each(function() {
      var $this = $(this);
      self.stringlists.push(
        new yext.location.StringList({
          container: $this,
          field: $this.data('fieldName'),
        }),
      );
    });
    this.setupDatepair();
    this.setupMultiSelects();
    this.bindAddItemContextualHelp();
    this.bindPhotoActions(add);
    this.bindOptionActions();
    this.bindVideoActions();
    this.bindCharCounts($('#enhanced-lists-wrapper'));
  }
  yext.dam.assetselector.init();
  yext.videochooser.init('video.value', window.enableSubmit);
};
goog.exportSymbol('yext.storm.enhancedlists.Items', yext.storm.enhancedlists.Items);

/**
 * Returns the number of photos already present on the item
 */
yext.storm.enhancedlists.Items.prototype.initTotalPhotos = function() {
  var $gallery = $('.gallery');
  if ($gallery.length) {
    return $gallery.find('.gallery-field-edit').find('li.photo:not(.template)').length;
  } else {
    var $singlePhoto = $('div.photo-single').find('img');
    if ($singlePhoto.attr('src')) {
      return 1;
    }
  }
  return 0;
};

/**
 * If there are unsaved fields, an on before unload message is added,
 * otherwise this message is cleared
 */
yext.storm.enhancedlists.Items.prototype.setBeforeUnload = function() {
  if (this.hasUnsavedFields()) {
    yext.helpers.addBeforeUnloadMessage();
  } else {
    yext.helpers.clearBeforeUnloadMessage();
  }
};

/**
 * Reload the ECL item page
 * Disable the dialog that confirms the page should be refreshed
 */
yext.storm.enhancedlists.Items.prototype.reload = function() {
  yext.helpers.clearBeforeUnloadMessage();
  window.location.reload();
};

/**
 * @return {boolean} True if the edit page has unsaved fields
 */
yext.storm.enhancedlists.Items.prototype.hasUnsavedFields = function() {
  var unsaved = false;
  $('.js-enhancedlists-table .submit').each(function() {
    if (!$(this).hasClass('disabled')) {
      unsaved = true;
      return false;
    }
  });
  return unsaved;
};

/**
 * Listens generally for changes on the add ECL page
 */
yext.storm.enhancedlists.Items.prototype.bindGeneralChangeListener = function() {
  var self = this;
  $('.js-enhancedlists-table').find('input, textarea, select').inputchange(function() {
    if ($(this).val() && $(this).val().length) {
      self.fieldEdited();
    }
  });
};

/**
 * Called when a field is edited. Adds on before unload message when on the
 * add page
 */
yext.storm.enhancedlists.Items.prototype.fieldEdited = function() {
  if (this.isAddState) {
    yext.helpers.addBeforeUnloadMessage();
  }
};

/**
 * Adds contextual tooltip item id information
 */
yext.storm.enhancedlists.Items.prototype.bindAddItemContextualHelp = function() {
  switch ($('input[name="type"]').val()) {
    case 'Menu':
      window.contextualHelp['internal-id'] = yext.msg('Your internal code for this menu. This will not be displayed to customers.');
      window.contextualHelp['internal-ids'] = yext.msg('Your internal codes for these menus. These will not be displayed to customers.');
      break;
    case 'ProductList':
      window.contextualHelp['internal-id'] = yext.msg('Your internal code for this list. This will not be displayed to customers.');
      window.contextualHelp['internal-ids'] = yext.msg('Your internal codes for these lists. These will not be displayed to customers.');
      break;
    case 'Calendars':
      window.contextualHelp['internal-id'] = yext.msg('Your internal code for this calendar. This will not be displayed to customers.');
      window.contextualHelp['internal-ids'] = yext.msg('Your internal codes for these calendars. These will not be displayed to customers.');
      break;
    case 'Bios':
      window.contextualHelp['internal-id'] = yext.msg('Your internal code for this list. This will not be displayed to customers.');
      window.contextualHelp['internal-ids'] = yext.msg('Your internal codes for these lists. These will not be displayed to customers.');
      break;
  }
  window.contextualHelp['id-code'] = yext.msg('A unique code for your product (e.g. SKU).');
};

yext.storm.enhancedlists.Items.prototype.bindFocus = function() {
  $('input[name="item-name"]').focus();
};

/**
 * Confirms edit if there are pending edits and proceeds if confirmed.
 * If a jQuery object row is passed in, then reenable the submit button of the row after
 * field is edited.
 *
 * @param {Function} editFunc callback function that edits the row
 * @param {!Object} $tr        jQuery object of the row being edited.
 */
yext.storm.enhancedlists.Items.prototype.confirmEdit = function(editFunc, $tr) {
  editFunc();
};

yext.storm.enhancedlists.Items.prototype.bindEditFormSubmit = function() {
  var self = this;
  $('.enhancedlists-table').on('submit', 'form.enhancedlists', function(e) {
    e.preventDefault();
    var $tr = $(this).parents('tr');
    var $form = $(this);
    $form.find('.validation-error').removeClass('validation-error');
    var data = []; // Key-Value Array form

    // Set all the timestamps first
    $('input[name^="timestamp-"]').each(function() {
      var $input = $(this);
      data.push({
        'name': $input.attr('name'),
        'value': $input.val(),
      });
    });

    // disable the submit button to avoid duplicate ajax calls
    self.disableEdit($tr);

    if ($form.hasClass('gallery')) {
      // This means we are talking about a photo gallery.
      // Set the field value and serialize the gallery
      data.push({
        'name': 'field',
        'value': $form.find('input[name=field]').val(),
      });

      var gallery = self.serializeGallery($form.find('li.photo:not(.template)'));
      data.push({
        'name': 'gallery',
        'value': gallery.gallery,
      });

      // If we have files, we need to do an upload.
      if (gallery.files) {
        // Form data gets initially set as {name, value} pairs in an array
        // The file uploader takes it as such
        gallery.formData = data;
        self.uploadNewFiles(gallery, false, $tr);
        return;
      }
    } else {
      if ($form.hasClass('string-list')) {
        var stringlist = new yext.location.StringList({
          container: $form,
          field: $form.find('input[name=field]').val(),
        });
        var stringListFormData = stringlist.serializeForm();
        var dataLen = stringListFormData.length;
        for (var ii = 0; ii < dataLen; ii++) {
          var dataObj = stringListFormData[ii];
          data.push({
            'name': dataObj.name,
            'value': dataObj.value,
          });
        }
      } else if ($form.hasClass('event-time')) {
        data = data.concat(self.i18nSerializeEventParams($(this)));
      } else {
        data = data.concat($form.serializeArray());
      }
    }

    $.ajax({
      dataType: 'json',
      type: 'POST',
      data: data,
      success: function(result) {
        if (self.isSuggestedEdit && !result.errors) {
          // Suggested edit has been saved, so simply refresh the page
          self.reload();
        } else {
          self.successHandler($tr, result);
        }
      },
    }).fail(yext.ajax.errorWrapper(function() {
      self.enableEdit($tr);
      yext.dialog.showErrorDialog(yext.msg('Unable to update list item.'));
    }));
  });
};

yext.storm.enhancedlists.Items.prototype.i18nSerializeEventParams = function($form) {
  var formValues = $form.serializeArray();

  for (var i = 0; i < formValues.length; i++) {
    switch (formValues[i].name) {
      case 'item-event-time-start-time':
      case 'item-event-time-end-time':
        formValues[i].value = $form
          .find('input[name=' + formValues[i].name + ']')
          .data().timepickerLegacyValue;
        break;
      case 'item-event-time-start-day':
      case 'item-event-time-end-day':
        formValues[i].value = yext.time.formatDate(
          $form.find('input[name=' + formValues[i].name + ']').datepicker('getDate'));
        break;
    }
  }
  return formValues;
};

/**
 *  Serialize a single photo field given the outer div
 */
yext.storm.enhancedlists.Items.prototype.serializeSinglePhoto = function($container) {
  var img = $container.find('img');
  var $img = $(img);
  var uploadData = $img.data('data') || {};
  var uploadFile = $img.data('file');
  var uploadFileInput = $img.data('fileInput');

  var data = {};

  if (uploadFile) {
    data.files = [uploadFile];
    data.fileInput = [uploadFileInput];
    uploadData.asset.fileIndex = 0;
  } else {
    uploadData.url = $img.data('url');
  }

  uploadData.index = 0;
  data.gallery = yext.JSON.stringify(uploadData);
  return data;
};

yext.storm.enhancedlists.Items.prototype.serializeGallery = function(photoLis) {
  // Add timestamps for each item
  var uploadIndex = 0;
  var fileIndex = 0;
  var images = [];
  var files = [];
  var fileInputs = [];
  var data = {};
  $.each(photoLis, function(i, li) {
    var $li = $(li);
    var img = $li.find('img');
    var $img = $(img);

    // Every image has data, and possible a file and fileInput, and alternate text
    var uploadData = $img.data('data');
    var uploadFile = $img.data('file');
    var uploadFileInput = $img.data('fileInput');
    var altText = $li.find('.js-alternate-text').val();

    if (altText !== '') {
      uploadData.alternateText = altText;
    }

    var check = $li.find('input[type="checkbox"]')[0];
    var submitPhoto = true;
    if (!check) {
      uploadData.indeterminate = false;
    } else {
      submitPhoto = check.checked || !!$(check).prop('indeterminate');
      uploadData.indeterminate = $(check).prop('indeterminate');
    }

    if (submitPhoto) {
      if (uploadFile) {
        files.push(uploadFile);
        fileInputs.push(uploadFileInput);
        // Need to set the asset fileIndex to what file we are on
        // Only gets incremented on photos added that are file related
        uploadData.asset.fileIndex = fileIndex;
        fileIndex += 1;
      }
      uploadData.index = uploadIndex;
      uploadIndex += 1;

      images.push(uploadData);
    }
  });
  if (files.length > 0) {
    data.files = files;
    data.fileInputs = fileInputs;
  }
  // Need to stringify the array, otherwise we can't upload
  data.gallery = yext.JSON.stringify(images);
  return data;
};

/**
 * Handles a response from an update request. $tr refers to the row containing
 * the field being edited.
 */
yext.storm.enhancedlists.Items.prototype.successHandler = function($tr, result) {
  var self = this;
  if (result.html) {
    $tr.find('td:eq(1)').html(result.html);
    this.bindCharCounts($tr);
    if (!result.stale) {
      $tr.removeClass('enhancedlists-row-edit');
    } else {
      // For stale updates on gallery, price and calories, we need to call
      // their respective setup functions, since these fields are generated
      // from x-templates.
      if ($tr.find('form.gallery').length > 0) {
        this.setupGallery($('form.gallery'));
      } else if ($tr.find('.editing-mode.price').length > 0) {
        this.setupPrice();
      } else if ($tr.find('.editing-mode.calories').length > 0) {
        this.setupCalories();
      } else if ($tr.find('.editing-mode.price-options').length > 0) {
        this.setupPriceOptions();
      } else if ($tr.find('.editing-mode.string-list').length > 0) {
        this.setupStringlist($tr);
      }
    }

    $tr.find('.display-mode').toggle(!result.stale);
    $tr.find('.editing-mode').toggle(!!result.stale);
    $tr.find('.savable').inputchange(function(e) {
      self.enableEdit($tr);
    });
    $tr.find('.submit').addClass('disabled');
    $tr.find('select').selectbox();

    // For YouTube video fields
    if ($tr.find('form.video').length > 0) {
      this.updateVideo($tr);
    }

    // Update timestamps for the items that got updated.
    if (result.timestamp && result.updatedItemIds) {
      $.each(result.updatedItemIds, function(index, value) {
        $('input[name="timestamp-' + value + '"]').val(result.timestamp);
      });
    }

    // Update delete item dialog and heading item name.
    var itemName = $('input[name="item-name"]').val();
    $('.delete-item-dialog').find('.item-name').text(itemName);
    $('.single-item-name').text(itemName);

    // Re-setup date/time pickers
    if ($tr.find('form.event-time').length) {
      this.setupDatepair();
    }
    // Re-setup multiselects
    if ($tr.find('form.js-ecl-multi-select').length) {
      this.setupMultiSelects();
    }
  }
  if (result.errors) {
    var numErrors = result.errors.length;
    var errors = [];
    for (var ii = 0; ii < numErrors; ii++) {
      var error = result.errors[ii];
      if ($.inArray(error.message, errors) == -1) {
        errors.push(error.message);
      }
      if (error.key) {
        $tr.find('input[name="' + error.key + '"]').addClass('validation-error');
      }
    }
    $tr.find('.item-field-error').show().html(errors.join('<br>'));
  }
  self.setBeforeUnload();
};

/**
 * Bind row hover to add the correct hover class.
 */
yext.storm.enhancedlists.Items.prototype.bindRowHover = function() {
  $('.enhancedlists-table tbody tr').mouseover(function() {
    if ($(this).hasClass('no-hover')) {
      return;
    }
    $('.enhancedlists-table .enhancedlists-row-hover').removeClass('enhancedlists-row-hover');
    $(this).addClass('enhancedlists-row-hover');
  }).mouseout(function() {
    $(this).removeClass('enhancedlists-row-hover');
  });
};

/**
 * Bind edit field.
 *
 * 1) Switch to editing mode on row click.
 * 2) Enable/disable submit button based on name content.
 * 3) Bind reset link.
 * 4) Bind submit button to edit field and show errors.
 */
yext.storm.enhancedlists.Items.prototype.bindFieldEdit = function() {
  var self = this;
  var $table = $('.enhancedlists-table');

  // Switch to editing mode on row click
  $table.on('click', 'tbody > tr', function(e) {
    var $this = $(this);
    if (!$this.hasClass('no-hover')) {
      self.setEditState($this);
    }
  });

  $('.enhancedlists-table .savable.various').inputchange(function(e) {
    self.clearVarious($(this).parents('tr'));
  });
  $('.enhancedlists-table .savable').inputchange(function(e) {
    self.enableEdit($(this).parents('tr'));
  });

  // Reset link
  $table.on('click', '.reset', function() {
    var $tr = $(this).parents('tr');
    $tr.removeClass('enhancedlists-row-edit');
    $tr.find('.error').text('').hide();
    $tr.find('.display-mode').show();
    $tr.find('.editing-mode').hide();
    $tr.find('.submit').addClass('disabled');
    $tr.find('form').get(0).reset();
    $tr.find('.notvarious').removeClass('.notvarious').addClass('various');
    $tr.find('.hide-on-reset-various').show();
    $tr.find('.show-on-reset-various').hide();
    self.setBeforeUnload();
    return false;
  });

  $table.on('click', '.reset-various', function() {
    var $tr = $(this).parents('tr');
    $tr.find('.error').text('').hide();
    $tr.find('.hide-on-reset-various').hide();
    $tr.find('.show-on-reset-various').show();
    self.enableEdit($tr);
  });

  // Submit button
  $table.on('click', '.enhancedlists-row-edit .submit:not(.disabled)', function() {
    $(this).parents('tr').find('form.enhancedlists').submit();
  });
};

/**
 * Sets a editable row to the edit state with form elements
 */
yext.storm.enhancedlists.Items.prototype.setEditState = function($this) {
  var self = this;

  if ($this.hasClass('enhancedlists-row-edit') || $this.hasClass('no-edit') || $this.hasClass('video')) {
    return;
  }

  // For gallery fields
  if ($this.find('form.gallery').length) {
    self.setupGallery($('form.gallery'));
  }

  if ($this.find('form.event-time').length) {
    self.setupDatepair();
  }

  // For price fields
  if ($this.find('.editing-mode.price').length) {
    self.setupPrice();
  }
  if ($this.find('.editing-mode.price-options').length) {
    self.setupPriceOptions();
  }

  // For calorie field
  if ($this.find('.editing-mode.calories').length) {
    self.setupCalories();
  }

  // For stringlist fields
  if ($this.find('.editing-mode.string-list').length) {
    self.setupStringlist($this);
  }

  $this.addClass('enhancedlists-row-edit');
  $this.find('.display-mode').hide();
  $this.find('.editing-mode').show();

  var textField = $this.find('input[type="text"], textarea').not(':hidden').first();
  if (!textField.hasClass('hasDatepicker')) {
    textField.focus();

    if (!textField.hasClass('various')) {
      textField.select();
    }
  }

  return false;
};

yext.storm.enhancedlists.Items.prototype.setupGallery = function($galleryForm) {
  if ($galleryForm.length == 0) {
    return;
  }
  var template = $galleryForm.find('.field-edit-template');
  var $fieldEdit = $galleryForm.find('.field-edit');
  var $tr = $galleryForm.closest('tr');
  if (template.length > 0) {
    $fieldEdit.html(template.html()).show();
    if ($tr.find('.various').length > 0) {
      this.addItemPhoto($galleryForm);
    }
  }

  // When we set up the gallery for editing, all the photos need to have
  // the urls stored as data. So convert the img urls
  // (these are images that already exist on the item) to Photo instances
  var liItems = $fieldEdit.find('li.photo:not(.template)');
  $.each(liItems, function(i, li) {
    var img = $(li).find('img');
    var $img = $(img);
    $img.data('data', new yext.photoupload.Photo({'url': $img.attr('src')}));
    $(li).find('.savable').inputchange(function(e) {
      self.enableEdit($(this).closest('tr'));
    });
  });

  // Enable re-order/indeterminate for gallery
  var edit = $galleryForm.find('.field-edit');
  var list = $galleryForm.find('.photo-list');
  edit.find('.indeterminate').prop('indeterminate', true);
  this.checkGalleryMax();
  var self = this;
  var maxPhotos = $('form.gallery').data('max');
  if (maxPhotos > 1) {
    list.sortable({
      axis: 'y',
      change: function() {
        edit.find('.reorder').hide();
        edit.find('input[name="reordered"]').val('true');
        self.enableEdit($tr);
      },
      stop: function(e, ui) {
        // Note (dwen): Firefox sets top/left to 0 on stop, which causes the
        // image to be misaligned the next time it gets dragged. Explicitly
        // set top/left to auto to fix this.
        ui.item
          .css('top', 'auto')
          .css('left', 'auto');
      },
      containment: edit,
      tolerance: 'pointer',
    });
  }

  // Bind checkbox listeners
  $('.gallery-edit-all-checkbox').change(function() {
    self.checkGalleryMax();
    list.find('input[type="checkbox"]')
      .removeProp('indeterminate')
      .prop('checked', $(this).prop('checked'));
  });
  edit.find('input[type="checkbox"]').bind('click', function(e) {
    self.checkGalleryMax();
    self.enableEdit($tr);
  });
};

yext.storm.enhancedlists.Items.prototype.setupPrice = function() {
  var $template = $('.price-template');
  var $edit = $('.editing-mode.price');
  $edit.html($template.html());

  var self = this;
  $edit.find('.savable').inputchange(function(e) {
    self.enableEdit($(this).closest('tr'));
  });
};

yext.storm.enhancedlists.Items.prototype.setupCalories = function() {
  var $template = $('.calories-template');
  var $edit = $('.editing-mode.calories');
  $edit.html($template.html());

  var self = this;
  $edit.find('.savable').inputchange(function(e) {
    self.enableEdit($(this).closest('tr'));
  });
};

/**
 * Sets up edit template for price options.
 * @param {!jQuery} $container containing DOM element of the options
 */
yext.storm.enhancedlists.Items.prototype.setupPriceOptions = function($container) {
  var $optionsTemplate = $('.price-options-template');
  var $optionsEdit = $('.editing-mode.price-options');
  $optionsEdit.html($optionsTemplate.html());

  var self = this;
  $optionsEdit.find('.savable').inputchange(function(e) {
    self.enableEdit($(this).closest('tr'));
  });

  var $optionList = $('.option-list');
  if ($container) {
    $optionList = $container.find('.option-list');
  }

  $optionList.sortable({
    axis: 'y',
    stop: function(e, option) {
      self.updateOptions($(option.item));
    },
    containment: $optionList,
    tolerance: 'pointer',
  });

  if (!$container) {
    if ($optionList.find('li:not(.template)').length == 0) {
    // Add single empty option by default if item has no options.
      self.addOption();
    }
  }
};

/**
 * Sets up the multiselects
 */
yext.storm.enhancedlists.Items.prototype.setupMultiSelects = function() {
  $('.js-ecl-item-multi-selector').listPicker(null, false, null);
};

/**
 * Bind user clicking 'Cancel' on the item creation (Add item) page.
 */
yext.storm.enhancedlists.Items.prototype.bindCancelCreate = function() {
  $('.cancel-event-create').click(function(e) {
    e.preventDefault();
    var href = $(this).attr('href');
    // Return to calendar view user was previously on
    window.location = href + (href.indexOf('?') >= 0 ? '&' : '?') + 'calendarView=' +
      $('input[name=calendarView]').val();
  });
};

/**
* Intially adding items to string list if it's empty
* currently only used in LOG but it can be used anywhere
* @param {!jQuery} $container - the dom element that contains the stringlist
*
*/
yext.storm.enhancedlists.Items.prototype.intializeStringList = function($container) {
  var stringLists = $container.find('.string-list');

  stringLists.each(function() {
    if ($(this).find('.stringlist-items > li').not('.template').length < 1) {
      $(this).find('.stringlist-add').click();
    }
  });
};

yext.storm.enhancedlists.Items.prototype.setupStringlist = function($tr) {
  var $template = $tr.find('.string-list-template');
  var $edit = $tr.find('.editing-mode.string-list');
  $edit.html($template.html());

  $('.savable').inputchange(function(e) {
    self.enableEdit($(this).parents('tr'));
  });
  var $form = $tr.find('form.string-list');
  var self = this;
  new yext.location.StringList({
    'container': $tr,
  });
};

yext.storm.enhancedlists.Items.prototype.handleDatepair = function(startDateInput, endDateInput, startTimeInput, endTimeInput) {
  var startDate = new Date(startDateInput.val());
  var endDate = new Date(endDateInput.val());
  var startDateMillis = startDate.getTime();
  var endDateMillis = endDate.getTime();

  var diffMillis = endDateMillis - startDateMillis;

  if (diffMillis > 0) {
    endTimeInput.timepicker('option', {
      showDuration: false,
      minTime: null,
    });
  } else {
    if (diffMillis < 0) {
      endDateInput.val(new Date(startDateMillis).format('yMd'));
    }
    endTimeInput.timepicker('option', {
      showDuration: true,
      minTime: startTimeInput.val(),
    });
    var startTime = startTimeInput.timepicker('getSecondsFromMidnight');
    var endTime = endTimeInput.timepicker('getSecondsFromMidnight');
    if (endTime <= startTime) {
      endTime = startTime + 3600;
      var oneDayInSeconds = 60 * 60 * 24;
      if (endTime >= oneDayInSeconds) {
        endTime %= oneDayInSeconds;
        endDate = startDateInput.datepicker('getDate');
        endDate = new Date(endDate.getTime() + oneDayInSeconds * 1000);
        endDateInput.val(endDate.format('yMd'));
        endTimeInput.timepicker('option', {
          showDuration: false,
          minTime: null,
        });
      }
      endTimeInput.timepicker('setTime', endTime);
    }
  }
};

/**
 * Setup datepicker and timepicker fields, bind display end time checkbox
 * and date/timepicker changes.
 */
yext.storm.enhancedlists.Items.prototype.setupDatepair = function(startDateInput, endDateInput, startTimeInput, endTimeInput, endContainer) {
  var self = this;
  if (startDateInput === undefined) {
    startDateInput = $('input[name="item-event-time-start-day"]');
    endDateInput = $('input[name="item-event-time-end-day"]');
    startTimeInput = $('input[name="item-event-time-start-time"]');
    endTimeInput = $('input[name="item-event-time-end-time"]');
    endContainer = $('.item-event-time-end');
  }

  // Check if there's a date input to set up.
  if (startDateInput.length == 0) {
    return;
  }

  // Set default start date to today
  if (!startDateInput.val()) {
    startDateInput.val(new Date().format('yMd'));
  }

  var datepickerOpts = {
    minDate: new Date(1970, 0, 1),
    maxDate: '+100Y',
  };

  startDateInput.datepicker(datepickerOpts);
  endDateInput.datepicker(datepickerOpts);

  $('#ui-datepicker-div').addClass('event-picker');

  var opts = {
    'showDuration': true,
    'timeFormat': 'hm',
    'scrollDefaultNow': true,
  };

  startTimeInput.timepicker(opts);
  endTimeInput.timepicker(opts);

  // Prevent duplicate bindings
  startTimeInput.unbind('changeTime', this.handleDatepair);
  endTimeInput.unbind('changeTime', this.handleDatepair);
  startDateInput.unbind('changeDate change', this.handleDatepair);
  endDateInput.unbind('changeDate change', this.handleDatepair);

  // Bind/Re-bind event listeners
  startTimeInput.bind('changeTime', function() {
    self.handleDatepair(startDateInput, endDateInput, startTimeInput, endTimeInput);
  });
  endTimeInput.bind('changeTime', function() {
    self.handleDatepair(startDateInput, endDateInput, startTimeInput, endTimeInput);
  });
  startDateInput.bind('changeDate change', function() {
    self.handleDatepair(startDateInput, endDateInput, startTimeInput, endTimeInput);
  });
  endDateInput.bind('changeDate change', function() {
    self.handleDatepair(startDateInput, endDateInput, startTimeInput, endTimeInput);
  });

  endContainer.toggle(endDateInput.length && endDateInput.val().length > 0);

  // Find the checkbox associated with this specific datepair.
  // Note that since several of these can be displayed at once (e.g. in LOG flow), just selecting
  // globally by name will cause some incorrect bindings.
  var $displayEndTime = startDateInput.closest('form.event-time').find('input[name=item-event-display-end-time]');
  $displayEndTime.unbind('click');
  $displayEndTime.click(function() {
    var $eventEndDiv = $(this).parents('.item-event-time-start').siblings('.item-event-time-end');
    var showEndTime = !$eventEndDiv.is(':visible');
    $eventEndDiv.toggle(showEndTime);
    if (showEndTime && !endDateInput.val()) {
      endDateInput.val(startDateInput.datepicker('getDate').format('yMd'));
    }
    self.handleDatepair(startDateInput, endDateInput, startTimeInput, endTimeInput);
  });

  this.handleDatepair(startDateInput, endDateInput, startTimeInput, endTimeInput);
};

/**
 * Toggle the add new photo link and maximum warnings.
 */
yext.storm.enhancedlists.Items.prototype.checkGalleryMax = function() {
  var maxPhotos = $('form.gallery').data('max');
  var el = $('.gallery-field-edit');
  var numCheckedPhotos;
  var numIndeterminatePhotos;
  if (el.find('.gallery-edit-checkbox').length > 0) {
    // Case where there are checkboxes
    numCheckedPhotos = el.find('li:not(.template) input:checked').length;
    numIndeterminatePhotos = el.find('li:not(.template) input:indeterminate').length;
  } else {
    // Case where there are no checkboxes
    numCheckedPhotos = el.find('li:not(.template)').length;
    numIndeterminatePhotos = 0;
  }
  var isAtLeastMax = numCheckedPhotos >= maxPhotos;
  var showOverMaxWarning = numCheckedPhotos + numIndeterminatePhotos > maxPhotos;
  $('.gallery .add-item-photo').toggle(!isAtLeastMax);
  el.find('.gallery-max').toggle(isAtLeastMax);
  el.find('.gallery-max-warning').toggle(showOverMaxWarning);
};

yext.storm.enhancedlists.Items.prototype.clearVarious = function($tr) {
  $tr.find('.various').removeClass('various').addClass('notvarious').val('');
};

yext.storm.enhancedlists.Items.prototype.enableEdit = function($tr) {
  $tr.find('.submit').removeClass('disabled');
  this.setBeforeUnload();
};

yext.storm.enhancedlists.Items.prototype.disableEdit = function($tr) {
  $tr.find('.submit').addClass('disabled');
};

/**
 * Bind video actions on ecl item page
 */
yext.storm.enhancedlists.Items.prototype.bindVideoActions = function() {
  var $tr = $('.js-add-video').closest('tr');
  var add = $tr.find('.videos').data('add');
  this.bindAddVideo($tr, add);
  this.bindRemoveVideo($tr, add);
};

/**
 * Bind adding/updating a video
 *
 * @param {!jQuery} $tr Table row that controls videos
 * @param {boolean} add Add or edit mode
 */
yext.storm.enhancedlists.Items.prototype.bindAddVideo = function($tr, add) {
  var self = this;

  $tr.closest('table').on('click', '.js-add-video', function(e) {
    e.stopPropagation();
    e.preventDefault();

    yext.dam.assetselector.show({
      type: yext.dam.assetselector.types.VIDEO,
      includeUsedAssets: false,
    }, 'youtube');

    $(yext.dam.assetselector.events).on('added.assetselector', function(e, asset) {
      // update input
      $tr.find('form.enhancedlists input[name="video.value"]')
        .val(asset.videoinfo.url);
      if (add) {
        // update hidden display url in order to generate preview
        $tr.find('.js-video-display-url').html(asset.videoinfo.url);
        self.updateVideo($tr);
      } else {
        $tr.find('form').submit();
        $tr.addClass('no-edit');
        $tr.removeClass('js-add-video');
      }
      self.fieldEdited();
    });
  });
};

/**
 * Bind removing a video
 *
 * @param {!jQuery} $tr Table row that controls videos
 * @param {boolean} add Add or edit mode
 */
yext.storm.enhancedlists.Items.prototype.bindRemoveVideo = function($tr, add) {
  var $dialog = $('.js-rm-video-dialog');
  var self = this;

  var removeDialog = $dialog.dialog({
    modal: true,
    draggable: false,
    resizable: false,
    autoOpen: false,
    title: yext.msg('Are you sure you want to remove this video?'),
    width: 355,
    height: 100,
  });

  $dialog.find('.danger').click(function() {
    var $form = $tr.find('form.enhancedlists');
    var $input = $form.find('input[name="video.value"]');

    $input.val('');
    if (!add) {
      $form.submit();
    }
    if (!self.isSuggestedEdit) {
      $('.js-add-video-link').show();
      $('.js-video-display-wrapper').hide();
      $tr.removeClass('no-edit');
      $tr.addClass('js-add-video');
    }
    removeDialog.dialog('close');
  });

  $dialog.find('.cancel').click(function() {
    removeDialog.dialog('close');
  });

  $tr.on('click', '.js-remove-video', function(e) {
    e.stopPropagation();
    e.preventDefault();
    removeDialog.dialog('open');
  });
};

/**
 * Update the video preview and info from saving the item
 *
 * @param {!jQuery Object} $tr The video row
 */
yext.storm.enhancedlists.Items.prototype.updateVideo = function($tr) {
  var $displayWrap = $tr.find('.js-video-display-wrapper');
  var videoSet = yext.videochooser.loadVideoDisplays($displayWrap);

  $('.js-add-video-link').toggle(!videoSet);
  $displayWrap.toggle(videoSet);
};

/**
 * Used to upload files for photo gallery to the server via ajax request
 * @param {!Object} data The data to be uploaded. If there are files to upload, stored in data.files, otherwise
 *             everything is in data.formData
 * @param {bool} add Add a new item
 * @param {!jQuery object} $row the jQuery row for uploading
 */
yext.storm.enhancedlists.Items.prototype.uploadNewFiles = function(data, add, $row) {
  var photoUploadTimeoutId = null;
  var self = this;

  var onFail = function(e, data) {
    if (photoUploadTimeoutId) {
      yext.dialog.hideDelayedProgressDialog(photoUploadTimeoutId);
      photoUploadTimeoutId = null;
    }
    // TRANSLATORS: The argument is an email address
    yext.dialog.showErrorDialog(yext.msg('An error has occurred. Please try again later or contact support'));
  };
  var onDone = function(data) {
    if (photoUploadTimeoutId) {
      yext.dialog.hideDelayedProgressDialog(photoUploadTimeoutId);
      photoUploadTimeoutId = null;
    }
    if (data) {
      var result = data;
      if (add) {
        // Add new item case. If suggested edit then reload.
        // Otherwise redirect to URL on success, show all errors
        // otherwise.
        if (data.isSuggestedEdit) {
          self.reload();
        } else {
          self.handleAddItemErrors(data);
        }
      } else {
        if (data.error) {
          yext.notify.showError(data.error);
        } else {
          self.successHandler($row, data);
          self.checkGalleryMax();
        }
      }
    }
  };

  // Handle multiple files for gallery
  const paramNames = [];
  for (let i = 0; i < data.files.length; i++) {
    paramNames.push('file' + i);
  }

  var options = data;
  options.data = data.formData;
  if (paramNames.length > 1) {
    options.paramName = paramNames;
  }
  options.done = onDone;
  options.fail = onFail;
  yext.fileupload.upload(options);
};

yext.storm.enhancedlists.Items.prototype.bindPhotoActions = function(add) {
  var self = this;
  var $table = $('.enhancedlists-table');

  $table.on('click', '.add-item-photo', function(e) {
    e.stopPropagation();
    self.addItemPhoto($(this));
  });

  $table.on('click', '.remove-item-photo', function(e) {
    e.stopPropagation();
    self.removePhotoItem($(this));
  });

  $table.on('click', '.photo-elided .remove-item', function(e) {
    e.stopPropagation();
    self.removeItem($(e.target));
  });
};

yext.storm.enhancedlists.Items.prototype.addItemPhoto = function($el) {
  var isGallery = $el.closest('.gallery').length > 0;
  var $row = $el.closest('tr');
  var photoUploadTimeoutId = null;
  var self = this;

  if (isGallery && !this.isAddState) {
    // Show edit mode on addPhoto click.
    $(this).closest('.enhancedlists-row-hover').click();
  }

  $('#add-photo-form').submit(function(e) {
    $(this).find('.files').find('.start button').click();
    return false;
  });


  yext.dam.assetselector.has.DAM = false;
  yext.dam.assetselector.show({
    type: yext.dam.assetselector.types.PHOTO,
    includeUsedAssets: false,
    hideEnterImageUrl: false,
  },
  null,
  false); // photos do not require approval for social post

  $(yext.dam.assetselector.events).on('added.assetselector', function(e, asset) {
    // faking the data for the onAdd function since I'm not cleaning up that mess
    self.onAddItemPhotoGallery(new yext.photoupload.Photo({'asset': asset}), $row, asset);
    self.fieldEdited();
  });
};

/**
 * Action handler for when a user clicks +Add Photo
 * @param {yext.photoupload.Photo} photo Photo object for uploading
 * @param {!Object} $row The jQuery row housing the photo
 * @param {!Object} asset The asset returned from the asset selector
 */
yext.storm.enhancedlists.Items.prototype.onAddItemPhotoGallery = function(photo, $row, asset) {
  var success = true;
  var file = asset.file;
  // show edit state
  this.setEditState($row);
  if (file && ((file.type && !file.type.match(/^image/))
      || (!file.type && !file.name.match(/\.(jpg|jpeg|png|tiff|gif|bmp)$/i)))) {
    yext.notify.showError(yext.msg('The file you selected is not a valid image. Please select an image file and try again.'));
    success = false;
  } else {
    var $photoLi = $('.photo-list .template').clone(true).show();
    $photoLi.removeClass('template');

    // workaround for IE 11 placeholder text bug
    $photoLi.find('.js-alternate-text').val('');

    // bind the remove icon
    $photoLi.find('.remove').bind('click', function(e) {
      $photoLi.remove();
    });

    // Let's set all the necessary data we need as data on the image tag
    var $img = $photoLi.find('img');
    if (asset.croppedImage) {
      $img.attr('src', asset.croppedImage);
    } else {
      $img.attr('src', asset.photoUrl);
    }

    $('.photo-list').append($photoLi);
    this.addDataToImage($img, photo, file, asset.fileInput);
  }

  if (success) {
    if (this.isAddState) {
      this.totalPhotos += 1;
    }
    this.checkGalleryMax();
    this.enableEdit($row);
  }
};

/**
 * Action handler for when a user clicks +Add Photo
 * @param {yext.photoupload.Photo} photo Photo object for uploading
 * @param {!Object} $row The jQuery row housing the photo
 * @param {!Object} asset The asset returned from the asset selector
 */
// Once you select a photo for a single photo field on the list, we assume you are
// setting it also and immediately submit it
yext.storm.enhancedlists.Items.prototype.onEditItemPhoto = function(photo, $row, asset) {
  var self = this;
  var file = asset.file;
  var $timestamp = $('input[name^="timestamp-"]');
  var field = $row.find('input[name=field]').val();

  if (file && photo.asset) {
    photo.asset.fileIndex = 0;
  }

  // data needed by both the uploader and the regular ajax
  var dataNeeded = {
    'photo': yext.JSON.stringify(photo),
    'field': field,
  };
  $.each($timestamp, function(i, t) {
    var timestampString = $(t).attr('name');
    dataNeeded[timestampString] = $(t).val();
  });

  if (yext.storm.enhancedlists.needsFileUpload(photo.croppedImage, file)) {
    // The file uploader needs form data to be an array of {name, value} pairs
    var formData = [];
    $.each(dataNeeded, function(key, value) {
      formData.push({'name': key, 'value': value});
    });
    var uploadData = {
      'files': [file],
      'fileInputs': [asset.fileInput],
      'formData': formData,
    };
    this.uploadNewFiles(uploadData, false, $row);
    return;
  } else {
    var uploadData = dataNeeded;
  }
  $.ajax({
    data: $.param(uploadData),
    type: 'post',
    success: function(result) {
      if (self.isSuggestedEdit && !result.errors) {
        // Suggested edit has been saved, so simply refresh the page
        self.reload();
      } else {
        self.successHandler($row, result);
      }
    },
  }).fail(yext.ajax.errorWrapper(function() {
    yext.dialog.showErrorDialog(yext.msg('Unable to update list item.'));
  }));
};

/**
 * Given an image tag, give it data from the photo, a file and the fileInput
 */
yext.storm.enhancedlists.Items.prototype.addDataToImage = function($img, data, file, fileInput) {
  $img.data('data', data);
  if (yext.storm.enhancedlists.needsFileUpload(data.croppedImage, file)) {
    $img.data('file', file);
    $img.data('fileInput', fileInput);
  }
};

/**
 * Action when a photo item is removed
 */
yext.storm.enhancedlists.Items.prototype.removeItem = function($el) {
  var $row = $el.closest('tr');

  $el.parents('form').find('input[name=elided]').val('0');
  $el.parents('.photo-elided').remove();
  this.enableEdit($row);
};

/**
 * Action when a user removed a photo item from an ecl
 */
yext.storm.enhancedlists.Items.prototype.removePhotoItem = function($link) {
  var $row = $link.closest('tr'); // was $tr
  var isGallery = $row.find('.gallery-edit-image').length > 0;

  if (isGallery) {
    $link.parents('li.photo').remove();
    if (this.isAddState) {
      this.totalPhotos -= 1;
    }
    this.checkGalleryMax();
    this.enableEdit($row);
  } else {
    this.createRemovePhotoDialog($link, $row);
  }
};

/**
 * Creates a Remove Photo Dialog to confirm the action
 * TODO(dp): remove this if not still needed for new single photo case
 */
yext.storm.enhancedlists.Items.prototype.createRemovePhotoDialog = function($link, $photoContainer) {
  this.$removePhotoDialog = $('.remove-photo-dialog');
  var self = this;

  this.$removePhotoDialog.dialog('open');
  this.$removePhotoDialog.find('.danger').unbind('click');

  this.$removePhotoDialog.find('.danger').click(function() {
    self.onRemovePhotoDialogConfirm($link, $photoContainer);
  });
};

/**
 * Action on remove photo dialog confirm
 */
yext.storm.enhancedlists.Items.prototype.onRemovePhotoDialogConfirm = function($link, $photoContainer) {
  var self = this;
  if (this.isAddState) {
    // Adding new item case. Release previous photo data from DOM.
    this.totalPhotos -= 1;
    $photoContainer.find('.photo').removeData('data');
    $photoContainer.find('.photo-add-controls').show();
    $photoContainer.find('.photo-replace-controls').hide();
    $photoContainer.find('.photo-single').hide();
  } else {
    // editing existing item case (Replace)
    var data = {
      'field': this.$removePhotoDialog.find('input[name=field]').val(),
      'delete-photo': true,
    };

    $('input[name^="timestamp-"]').each(function() {
      data[$(this).attr('name')] = $(this).val();
    });

    $.ajax({
      dataType: 'json',
      type: 'POST',
      data: data,
      success: function(result) {
        if (self.isSuggestedEdit && !result.errors) {
          // Suggested edit has been saved, so simply refresh the page
          self.reload();
        } else {
          self.successHandler($photoContainer, result);
        }
      },
    }).fail(yext.ajax.errorWrapper(function() {
      yext.dialog.showErrorDialog(yext.msg('Unable to update list item.'));
    }));
  }
  this.$removePhotoDialog.dialog('close');
};

/**
 * Update the view of the update Options and max and mins
 * @param {!jQuery} $option the option dom element (could be the template),
 * only used to find option list/container
 */
yext.storm.enhancedlists.Items.prototype.updateOptions = function($option) {
  var $optionList = $option.closest('.option-list');
  var $options = $optionList.find('li:not(.template)');
  var $optionContainer = $optionList.closest('.price-options-field');
  var $tr = $optionList.closest('tr');
  $options.each(function(i, el) {
    $(el).find('.option-text-input').attr('name', 'item' + i + '-option-text');
    $(el).find('.option-price-input').attr('name', 'item' + i + '-option-price');
    $(el).find('.option-calories-input').attr('name', 'item' + i + '-option-calories');
  });
  $options.find('.reorder-icon, .remove-item').toggle($options.length != 1);
  this.enableEdit($tr);
};

yext.storm.enhancedlists.Items.prototype.bindOptionActions = function() {
  var self = this;
  var $table = $('.enhancedlists-table');
  $table.on('click', '.add-item-option', function() {
    self.addOption();
  });
  $table.on('click', '.option-list .remove', function() {
    var $tr = $(this).closest('tr');
    $(this).closest('li').remove();
    // Pass in the template as the "updated option" so that the empty case is handled correctly
    self.updateOptions($tr.find('li.template'));
  });
};

yext.storm.enhancedlists.Items.prototype.addOption = function() {
  var $optionLi = $('.option-list .template').clone(true).show();
  $optionLi.removeClass('template');

  $('.option-list').append($optionLi);
  this.updateOptions($optionLi);
};

yext.storm.enhancedlists.Items.prototype.handleAddItemErrors = function(result) {
  var $createItemSave = $('.create-item-save');
  if (result.url) {
    window.location = result.url;
  } else if (result.errors) {
    $createItemSave.removeClass('disabled');
    $('.review-errors-message').show();
    var numErrors = result.errors.length;
    for (var ii = 0; ii < numErrors; ii++) {
      var error = result.errors[ii];
      var $errorInput = $('[name="' + error.key + '"]');
      var $error;
      if ($errorInput.length > 0) {
        $error = $errorInput.closest('td').find('.item-field-error');
        $errorInput.addClass('validation-error');
      } else {
        $error = $('.add-item-error');
      }
      if ($error.is(':visible')) {
        if ($error.text().indexOf(error.message) == -1) {
          $error.append('<br>' + error.message);
        }
      } else {
        $error.show().text(error.message);
      }
    }
  } else if (result.error) {
    $createItemSave.removeClass('disabled');
    $('.add-item-error').text(result.error).show();
  }
};

yext.storm.enhancedlists.Items.prototype.bindAddItemFormSubmit = function() {
  var self = this;
  var submitAddItemForm = function(addAnother) {
    yext.helpers.clearBeforeUnloadMessage();

    var $createItemSave = $('.create-item-save');
    if ($createItemSave.hasClass('disabled')) {
      return;
    } else {
      $createItemSave.addClass('disabled');
    }

    // Clear old errors
    $('.error').hide();
    $('.item-field-error').text('');
    $('.validation-error').removeClass('validation-error');

    var formData = [];

    var $listId = $('.js-list-id');
    if ($listId.length) {
      formData = formData.concat($listId.serializeArray());
    }

    $('form.enhancedlists:not(.gallery):not(.string-list)').each(function() {
      var formValues = [];
      if ($(this).hasClass('event-time')) {
        formValues = self.i18nSerializeEventParams($(this));
      } else {
        formValues = $(this).serializeArray();
      }
      formData = formData.concat(formValues);
    });

    // get the Stringlist Form Data
    $.each(self.stringlists, function() {
      var stringListFormData = this.serializeForm();
      formData = formData.concat(stringListFormData);
    });

    // Indicate if user has clicked 'Save and add another'
    if (addAnother) {
      formData.push({'name': 'add-another', 'value': true});
    }

    // Calendar view user came from
    if ($('input[name=calendarView]').val()) {
      formData['calendarView'] = $('input[name=calendarView]').val();
    }

    // Check for photo data in DOM.
    var dataWithPhotoUpload;
    if (self.totalPhotos && self.totalPhotos > 0) {
      var $photoLi = $('li.photo:not(.template)');
      if ($photoLi && $photoLi.length > 0) {
        // The ecl has a gallery
        var gallery = self.serializeGallery($photoLi);
        formData.push({'name': 'gallery', 'value': gallery.gallery});
        if (gallery.files) {
          dataWithPhotoUpload = gallery;
          dataWithPhotoUpload.formData = formData;
        }
      } else {
        // the ecl has a single photo
        var $singlePhoto = $('div.photo-single');
        var photo = self.serializeSinglePhoto($singlePhoto);
        formData.push({'name': 'photo', 'value': photo.gallery});
        if (photo.files) {
          dataWithPhotoUpload = photo;
          dataWithPhotoUpload.formData = formData;
        }
      }
    }


    if (dataWithPhotoUpload) {
      self.uploadNewFiles(dataWithPhotoUpload, true, $(this).closest('tr'));
      $createItemSave.removeClass('disabled');
    } else {
      // No photo was uploaded. Do simple post.
      $.ajax({
        type: 'POST',
        data: formData,
        success: function(htmlEncodedJson) {
          if (!htmlEncodedJson.isSuggestedEdit) {
            var result = $.parseJSON($('<div/>').html(htmlEncodedJson).text());
            self.handleAddItemErrors(result);
          } else {
            window.location.reload();
          }
        },
      });
    }
  };

  $('.create-item-save').click(function(e) {
    e.preventDefault();
    var addAnother = $(this).hasClass('add-another');
    submitAddItemForm(addAnother);
  });

  $('form.enhancedlists').submit(function(e) {
    e.preventDefault();
    submitAddItemForm(true /* redirect to add another */);
  });
};

yext.storm.enhancedlists.Items.prototype.bindDeleteItem = function() {
  var self = this;
  var $dialog = $('.delete-item-dialog');
  $dialog.find('.error').hide();
  $('.delete-item').click(function() {
    var title = $(this).text();
    $dialog.dialog({
      autoOpen: true,
      modal: true,
      draggable: false,
      resizable: false,
      title: title,
      width: 355,
    });
  });
  $dialog.find('.cancel').click(function() {
    if ($dialog.data('ui-dialog')) {
      $dialog.dialog('destroy');
    }
    return false;
  });
  $dialog.find('.primary').click(function() {
    $(this).addClass('disabled');
    var deleteSections = false;
    if ($dialog.find('input[name=delete-sections]:checked').length) {
      deleteSections = true;
    }
    $.ajax({
      dataType: 'json',
      type: 'POST',
      data: {'delete': true, 'deleteSections': deleteSections},
      success: function(result) {
        if (result.url) {
          window.location = result.url;
        } else if (result.error) {
          $(this).removeClass('disabled');
          $dialog.find('.error').text(result.error).show();
        }
      },
    });
  });
};

yext.storm.enhancedlists.Items.prototype.bindCharCounts = function($container) {
  var itemName = $container.find('input#item-name');
  itemName.inputchange(function() {
    window.updateCharCount($(this), 100, 'item-low-count');
  });

  var eventType = $container.find('input#item-event-type');
  eventType.inputchange(function() {
    window.updateCharCount($(this), 100, 'item-low-count');
  });

  var itemDescription = $container.find('textarea#item-description');
  itemDescription.inputchange(function() {
    window.updateCharCount($(this), 5000, 'item-low-count');
  });

  var itemTitle = $container.find('input#item-title');
  itemTitle.inputchange(function() {
    window.updateCharCount($(this), 100, 'item-low-count');
  });
};

/**
 * wrapper around enhancedlists Items for Log specific items
 * @constructor
 */
yext.storm.enhancedlists.LOGItems = function() {
  return new yext.storm.enhancedlists.Items(null, true);
};
goog.exportSymbol('yext.storm.enhancedlists.LOGItems', yext.storm.enhancedlists.LOGItems);

/**
 * Wrapper around enhancedlists Items for Add State
 * @constructor
 */
yext.storm.enhancedlists.AddItems = function() {
  return new yext.storm.enhancedlists.Items(true);
};
goog.exportSymbol('yext.storm.enhancedlists.AddItems', yext.storm.enhancedlists.AddItems);
